export default __webpack_public_path__ + "static/media/trr-drink-specialtycoffee-electriclemonade.19e605c4.png";